import type { RouteLocation } from "vue-router";
import { callWithNuxt, defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from "#app";
import { useCurrentCulture, $redirectResource, isInitialClientLoad } from "#imports";

export default defineNuxtRouteMiddleware( async ( to: RouteLocation ) => {
  // This guard stops API calls from being made twice, one on the server and
  // one on the client, on initial page load.
  if ( isInitialClientLoad() ) {
    return;
  }

  const nuxtApp = useNuxtApp();

  // trim trailing slashes from all routes
  if ( to.path.length > 1 && to.path.endsWith( "/" ) ) {
    return navigateTo( to.path.substring( 0, to.path.length - 1 ) );
  }

  const { getForUrl } = $redirectResource();
  const culture = useCurrentCulture();

  const data = await getForUrl( to.fullPath, culture.value || undefined );

  if ( data ) {
    let url = data.url;

    if ( data.query ) {
      const searchParams = new URLSearchParams( data.query );
      url += "?" + searchParams.toString();
    }

    // TODO: Using callWithNuxt is a fix for navigateTo erroring
    return callWithNuxt( nuxtApp, navigateTo, [url, {
      redirectCode: data.status,
      replace: true,
      external: true,
    }] );
  }
} );
